module.exports = __webpack_public_path__ + "static/media/ic-check.be7f9097.svg";